import { createContext, useContext } from 'react';

export const PeliConfigContext = createContext<Record<string, Record<string, string>>>({});

export const usePeliConfig = (category: string) => {
  const config = useContext(PeliConfigContext);

  return config?.[category] ?? {};
};
